import axios from './index';

const setAuthorizationHeaders = (accessToken = nulll) => {
    if (window.location.origin.includes('localhost')) console.log(accessToken, '<==== setAuthorizationHeaders');
    if (accessToken && window.location.origin.includes('localhost')) axios.defaults.headers.Authorization = `Bearer ${accessToken}`;
};
export default setAuthorizationHeaders;
